import { render, staticRenderFns } from "./ObjectTypesNew.vue?vue&type=template&id=9e8ac92e&"
import script from "./ObjectTypesNew.vue?vue&type=script&lang=js&"
export * from "./ObjectTypesNew.vue?vue&type=script&lang=js&"
import style0 from "./ObjectTypesNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports